import { Schema, number, string, isodate, array, bool } from 'lib/schema';
import { resolve } from 'acast-www-utils';

export const DEFAULT_COVER_IMAGE = '/assets/images/default-episode.png';
export const RSS_SUBTITLE_LIMIT = 255;

const DefaultISODate = () => new Date().toISOString();
const DefaultArray = () => [];

export default class Show extends Schema {
  @string id = { default: null };

  @isodate created = { default: DefaultISODate };

  @isodate modified = { mutable: true, default: DefaultISODate };

  @string name = { mutable: true, default: '' };

  @string description = { mutable: true, default: '' };

  @string network = { default: null };

  @string rating = { mutable: true, default: 'no' };

  @string image = { mutable: true, path: 'image.original', default: null };

  @string homepage = { mutable: true, default: '' };

  @string language = { mutable: true, default: 'sv' };

  @number popularity = { default: 0 };

  @number midrollThreshold = { default: 1200 };

  @array permalinks = { default: DefaultArray };

  @array categories = { mutable: true };

  @array keywords = { mutable: true };

  @array tags = { mutable: true, default: DefaultArray };

  @array integrations = { default: DefaultArray };

  @bool exclusive;

  @bool featured;

  @string rssSubtitle = { mutable: true, path: 'rss.subtitle', default: '' };

  @string rssSummary = { mutable: true, path: 'rss.summary', default: '' };

  @string rssAuthor = { mutable: true, path: 'rss.author', default: '' };

  @string rssEmail = { mutable: true, path: 'rss.ownerEmail', default: '' };

  @string showType = { mutable: true, default: 'episodic' };

  get url() {
    return this.permalinks[0] || null;
  }

  /**
   * Always return a copy of our flags array
   */
  @array
  flags = {
    mutable: true,
    resolve(state) {
      return resolve(state, 'flags', []).slice(0);
    },
  };

  @array products = { default: DefaultArray };
}
